import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headers: [],
    Role:'',
    filters: [{
      key: 'code',
      title: 'کد',
      value: '',
      type: 'number'
    }],
    items: [],
    profileImg : '',
    module: '',
    hide_footer: true,
    userName:'',
    amount:'',
    code:'',
    groupHeaders: [],
    pageNumber: 1,
    pageSize: 10,
    loading: false,
    pageTitle: 'عنوان صفحه',
    tableHeads: [],
    Actions:[],
    sortOrder: '',
    paging: {},
  },
  getters: {
    getData: state => {
      return state.data
    },
    getRole : state => {
      return state.Role
    },
    getGroupHeaders: state => {
      return state.groupHeaders
    },
    getFilters: state =>{
      return state.filters
    },
    getAmount: state =>{
      return state.amount
    },
    getUser: state =>{
      return state.userName
    },
    getCode: state =>{
      return state.code
    },
  },

  mutations: {
    setAmount: (state, payload) => {
      state.amount = payload
    },
    setUser: (state, payload) => {
      state.userName = payload
    },
    setCode: (state, payload) => {
      state.code = payload
    },
    setPageTitle: (state, payload) => {
      state.pageTitle = payload
    },
    setHide_footer: (state, payload) => {
      state.hide_footer = payload
    },
    setTableHeads: (state, payload) => {
      state.headers = payload
    },
    setGroupHeaders: (state, payload) => {
      state.groupHeaders = payload
    },
    setModule: (state, payload) => {
      state.module = payload
    },
    setActions: (state, payload) => {
      state.Actions = payload
    },
    setRole : (state , payload) =>{
      console.log('cdsojmdsojm')
      state.Role = localStorage.getItem('Role')
    },
    setProfileImg(state , payload){
      state.profileImg = payload
    },
    setFilters: (state, payload) => {
      state.filters = [{
        hasFilter: false,
        type: ''
      }]
      state.filters.push(...payload)
    },
  },
  actions: {},
  modules: {}
})
